import type { ReactNode } from "react";

/** The frame each group of settings sits in — matches the dial settings sections. */
export function SettingsCard({ title, hint, children }: { title: string; hint?: string; children: ReactNode }) {
  return (
    <div className="kd-card" style={{ padding: "var(--pad-card)", display: "flex", flexDirection: "column", gap: 12 }}>
      <div>
        <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text)" }}>{title}</div>
        {hint && (
          <div style={{ marginTop: 3, fontSize: 13, lineHeight: 1.55, color: "var(--text-muted)" }}>{hint}</div>
        )}
      </div>
      {children}
    </div>
  );
}
